import { 
    GAME_FACT_START, 
} from '../../constants.js'
import { StartDto } from '../../gamefacts/generic/StartDto.js'

export const genericResolvers = {
    [GAME_FACT_START]: (event) => new StartDto(event),
}